<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16dkHXW/tc-custom/9781528945141.jpg?1705056296521" alt="This image is the cover for the book Anxiety, It's Time to Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anxiety, It's Time to Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Anxiety, It's Time to Go is not just another self-help book. It is 'the' self-help book. It uses cutting-edge tried and tested methods that have been used time and time again to remove anxiety from people each and every day. Anxiety, It's Time to Go will explain everything in simple terms and then show you exactly how to combat the things that hurt and control us when it comes to anxiety. The easy-to-follow exercise and instructions have been made straightforward without all the psychobabble that most people use. We say it as it is and then show you exactly how to remove it. This might just be the best thing you have done when it comes to beating crippling anxiety once and for all. Review: I was given the book to read and I loved it. It was one of those books that I did not want to put down but equally did not want to finish, as I was enjoying it too much (like saving a new dress 'for best'). It was all so simple, it made sense and it worked!!! Now, I am not going to elaborate more, because I am now too busy living anxiety-free! Too busy enjoying life. Planning life. Too happy to even think about the old me who wasted so much time feeling anxious, stressed, miserable, not wanting to be here. So, read it for yourself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Mullin
      </h2>
      
      <p class="authorDescription body article">Kevin Mullin enlisted in the British Army aged fifteen years and eight months. He served in several conflict areas and operations around the globe, then at the age of thirty-four, he left the service and became a private military operator. Kevin was contracted to the United States Department of Defense, securing and protecting US Military bases and assets in Afghanistan. Kevin worked there for four years before moving to one of the most valuable targets in Afghanistan in the heart of Kabul - The Serena Hotel. Kevin studied NLP within the British Army and gained a wealth of knowledge and experience, training the trainers in the methods of approaches to NLP. Having suffered the loss of both his brother and mother, he was crippled with anxiety for many years. Kevin searched relentlessly for new, dynamic ways to beat it. Having taken an apprenticeship with Ali Campbell, Kevin finally found what he was looking for. He understudied and role modelled Ali to great effect. In June 2017, Kevin opened his very own NLP practice based in Central Scotland. The practice has received rave reviews about Kevin's new, dynamic and direct approach. He has helped thousands of clients become anxiety-free. Kevin has gained plaudits from Italy, Dubai and America for his dynamic and enthusiastic approach to motivational speaking and helping businesses and organisations flourish and grow. He is also a full-time parent. He raises his children with the approach he takes in life and in his crusade to help everyone in the battle with anxiety. Drive, determination and a vigour unparalleled in this modern age.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?264808f8